import React from 'react';
import './OptionSwitchCard.css';

const OptionSwitchCard = ({
  title,
  description,
  badgeText,
  icon,
  value,
  onChange,
}) => {
  const handleToggle = () => onChange(!value);

  const handleKeyDown = e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleToggle();
    }
  };

  return (
    <div
      className="option-switch-card"
      onClick={handleToggle}
      onKeyDown={handleKeyDown}
      role="switch"
      aria-checked={value}
      tabIndex={0}
    >
      <div className="option-switch-card-left">
        {icon && <div className="option-switch-card-icon">{icon}</div>}

        <div className="option-switch-card-info">
          <div className="option-switch-card-header">
            <span className="option-switch-card-title" title={title}>
              {title}
            </span>
            {badgeText && (
              <span className="option-switch-card-badge">{badgeText}</span>
            )}
          </div>

          <div className="option-switch-card-description-wrapper">
            {description && (
              <p className="option-switch-card-description">{description}</p>
            )}
          </div>
        </div>
      </div>

      <div className={`option-switch ${value ? 'is-active' : ''}`}>
        <div className="option-switch-handle" />
      </div>
    </div>
  );
};

export default OptionSwitchCard;
